import React from 'react';

export const SEARCH_ITEM_LOGO_SIZE = 40;

export const FallbackLogoSVG = ({ letter }: { letter: string }) => (
  <svg
    fill="none"
    height={SEARCH_ITEM_LOGO_SIZE}
    style={{ borderRadius: 4, display: 'block', flexShrink: 0, overflow: 'hidden' }}
    viewBox={`0 0 ${SEARCH_ITEM_LOGO_SIZE} ${SEARCH_ITEM_LOGO_SIZE}`}
    width={SEARCH_ITEM_LOGO_SIZE}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect fill="#024A7A" height={SEARCH_ITEM_LOGO_SIZE} rx={4} width={SEARCH_ITEM_LOGO_SIZE} />
    <text
      dominantBaseline="central"
      fill="#FFFFFF"
      fontFamily="system-ui, -apple-system, sans-serif"
      fontSize={22}
      fontWeight={600}
      textAnchor="middle"
      x="50%"
      y="50%"
    >
      {letter}
    </text>
  </svg>
);
